import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getWorkerMessages } from 'api/message'
import { useAuthContext } from 'components/auth'
import { workerMessagesKey } from './keys'

export function useWorkerMessages(workerId: number) {
  const { company } = useAuthContext()

  return useQuery({
    queryKey: workerMessagesKey(Number(workerId)),
    queryFn: () => {
      if (!company?.id) {
        throw new Error('Company ID not found')
      }
      return getWorkerMessages(company.id, workerId)
    },
    enabled: Boolean(company?.id),
  })
}

export function useInvalidateWorkerMessages(workerId: number) {
  const queryClient = useQueryClient()

  return {
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: workerMessagesKey(Number(workerId)),
      }),
  }
}
